import e from "../managers/braze-instance.js";
import er from "./feature-flags-provider.js";
const ir = {
  t: !1,
  provider: null,
  er: () => (
    ir.o(),
    ir.provider ||
      ((ir.provider = new er(e.tr(), e.ar(), e.l())), e.dr(ir.provider)),
    ir.provider
  ),
  o: () => {
    ir.t || (e.g(ir), (ir.t = !0));
  },
  destroy: () => {
    (ir.provider = null), (ir.t = !1);
  },
};
export default ir;
